import _slicedToArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

function _classPrivateFieldLooseBase(e, t) {
  if (!{}.hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
  return e;
}

var id = 0;

function _classPrivateFieldLooseKey(e) {
  return "__private_" + id++ + "_" + e;
}

var _uppy =
/*#__PURE__*/
_classPrivateFieldLooseKey("uppy");

var _events =
/*#__PURE__*/
_classPrivateFieldLooseKey("events");
/**
 * Create a wrapper around an event emitter with a `remove` method to remove
 * all events that were added using the wrapped emitter.
 */


var EventManager =
/*#__PURE__*/
function () {
  function EventManager(uppy) {
    _classCallCheck(this, EventManager);

    Object.defineProperty(this, _uppy, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _events, {
      writable: true,
      value: []
    });
    _classPrivateFieldLooseBase(this, _uppy)[_uppy] = uppy;
  }

  _createClass(EventManager, [{
    key: "on",
    value: function on(event, fn) {
      _classPrivateFieldLooseBase(this, _events)[_events].push([event, fn]);

      return _classPrivateFieldLooseBase(this, _uppy)[_uppy].on(event, fn);
    }
  }, {
    key: "remove",
    value: function remove() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = _classPrivateFieldLooseBase(this, _events)[_events].splice(0)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref3 = _step.value;

          var _ref2 = _slicedToArray(_ref3, 2);

          var event = _ref2[0];
          var fn = _ref2[1];

          _classPrivateFieldLooseBase(this, _uppy)[_uppy].off(event, fn);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "onFilePause",
    value: function onFilePause(fileID, cb) {
      this.on('upload-pause', function (file, isPaused) {
        if (fileID === (file == null ? void 0 : file.id)) {
          cb(isPaused);
        }
      });
    }
  }, {
    key: "onFileRemove",
    value: function onFileRemove(fileID, cb) {
      this.on('file-removed', function (file) {
        if (fileID === file.id) cb(file.id);
      });
    }
  }, {
    key: "onPause",
    value: function onPause(fileID, cb) {
      this.on('upload-pause', function (file, isPaused) {
        if (fileID === (file == null ? void 0 : file.id)) {
          // const isPaused = this.#uppy.pauseResume(fileID)
          cb(isPaused);
        }
      });
    }
  }, {
    key: "onRetry",
    value: function onRetry(fileID, cb) {
      this.on('upload-retry', function (file) {
        if (fileID === (file == null ? void 0 : file.id)) {
          cb();
        }
      });
    }
  }, {
    key: "onRetryAll",
    value: function onRetryAll(fileID, cb) {
      var _this2 = this;

      this.on('retry-all', function () {
        if (!_classPrivateFieldLooseBase(_this2, _uppy)[_uppy].getFile(fileID)) return;
        cb();
      });
    }
  }, {
    key: "onPauseAll",
    value: function onPauseAll(fileID, cb) {
      var _this3 = this;

      this.on('pause-all', function () {
        if (!_classPrivateFieldLooseBase(_this3, _uppy)[_uppy].getFile(fileID)) return;
        cb();
      });
    }
  }, {
    key: "onCancelAll",
    value: function onCancelAll(fileID, eventHandler) {
      var _this = this;

      this.on('cancel-all', function () {
        if (!_classPrivateFieldLooseBase(_this, _uppy)[_uppy].getFile(fileID)) return;
        eventHandler.apply(void 0, arguments);
      });
    }
  }, {
    key: "onResumeAll",
    value: function onResumeAll(fileID, cb) {
      var _this4 = this;

      this.on('resume-all', function () {
        if (!_classPrivateFieldLooseBase(_this4, _uppy)[_uppy].getFile(fileID)) return;
        cb();
      });
    }
  }]);

  return EventManager;
}();

export { EventManager as default };